import { INIT_PAGE_STATE } from "../../constant/constant";

export const RECOVERY_LOG_GET_LIST = "RECOVERY_LOG_GET_LIST";
export const RECOVERY_LOG_GET_LIST_SUCCESS = "RECOVERY_LOG_GET_LIST_SUCCESS";
export const RECOVERY_LOG_GET_LIST_ERROR = "RECOVERY_LOG_GET_LIST_ERROR";

export const loadRecoveryLogList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      limit: INIT_PAGE_STATE.pageSizes[0],
      startDate: null,
      endDate: null,
      date: null,
      username: null,
    },
    ...p,
  };
  const payload = {
    selectedPage: param.selectedPage,
    limit: param.limit,
    startDate: param.startDate,
    endDate: param.endDate,
    date: param.date,
    username: param.username,
  };
  return {
    type: RECOVERY_LOG_GET_LIST,
    payload,
  };
};

export const loadRecoveryLogListSuccess = (data) => ({
  type: RECOVERY_LOG_GET_LIST_SUCCESS,
  payload: data,
});

export const loadRecoveryLogListError = (error) => ({
  type: RECOVERY_LOG_GET_LIST_ERROR,
  payload: error,
});
